import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumbs from '../common/components/Breadcrumbs';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { fetchChanges } from './RequestFormChangesActions';
import RequestForChangesTable from './table/RequestForChangesTable';
import { scrollToElement } from '../common/helpers/scrollToElement';

const breadcrumbsItems = [
  { id: 1, type: 'home' },
  { id: 2, type: 'span', text: 'Requests' },
];

const RequestForChangesPage = ({ history, location }) => {
  const query = useQueryString();
  const dispatch = useDispatch();

  const items = useSelector(state => state.requests.get('items'));
  const selectedChangeRequestId = useSelector(state =>
    state.requests.get('selectedChangeRequestId'),
  );
  const totalItems = useSelector(state => state.requests.get('totalItems'));

  const [scrolledToElem, setScrolledToElem] = useState(false);
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  });

  useEffect(() => {
    setTimeout(() => {
      if (!scrolledToElem && selectedChangeRequestId && items) {
        scrollToElement(`change-request-row-${selectedChangeRequestId}`);
        setScrolledToElem(true);
      }
    }, 100);
  }, [selectedChangeRequestId, items, scrolledToElem]);

  useEffect(() => {
    dispatch(fetchChanges(searchParams));
  }, [dispatch, searchParams]);

  const changeOffset = value => {
    setSearchParams(prevState => ({ ...prevState, offset: value }));
    history.push(setQueryString(location, 'page', value + 1));
  };

  return (
    <div className="content">
      <Breadcrumbs items={breadcrumbsItems} />
      <RequestForChangesTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
      />
    </div>
  );
};

export default withRouter(RequestForChangesPage);
